import type {
  BookingCompletionSideEffectsV2GetApiData,
  BookingCompletionSideEffectsV2GetApiResponses
} from '@navio/nsdk';
import { apiUrl, dataEndpoint } from '../defineResource';

export const bookingCompletionUrls = {
  getBookingCompletionSideEffects: dataEndpoint<
    BookingCompletionSideEffectsV2GetApiData,
    BookingCompletionSideEffectsV2GetApiResponses
  >({
    getUrl: ({ bookingId }) => apiUrl(`bookings/${bookingId}/completion-side-effects/v2/`)
  })
};
